import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import useReveal from '../../hooks/useReveal';

const services = [
  {
    icon: 'fas fa-drafting-compass',
    title: 'Architectural Design',
    description:
      'Site-responsive architecture that balances form, function, climate, and constructability — from concept sketches to build-ready documentation.',
  },
  {
    icon: 'fas fa-hard-hat',
    title: 'Design & Construction',
    description:
      'Integrating design with execution to maintain control over detailing, material quality, and on-site accuracy.',
  },
  {
    icon: 'fas fa-key',
    title: 'Turnkey Delivery',
    description:
      'A single accountable partner for the full project lifecycle — planning, approvals, construction, interiors, and handover.',
  },
  {
    icon: 'fas fa-couch',
    title: 'Interior Architecture',
    description:
      'Interiors as an extension of the architecture — focusing on flow, ergonomics, lighting, texture, and durability.',
  },
  {
    icon: 'fas fa-project-diagram',
    title: 'Structural Collaboration',
    description:
      'Working with engineering consultants on intelligent structural systems that support architectural intent and long-term safety.',
  },
];

const Services = () => {
  const sectionRef = useRef(null);
  useReveal(sectionRef, '.apple-service', { y: 40, stagger: 0.08 });

  return (
    <section className="apple-section" id="services" ref={sectionRef}>
      <div className="apple-wrap apple-center">
        <span className="apple-eyebrow">What we do</span>
        <h2 className="apple-display">
          Services built around <span className="apple-italic">clarity</span>
        </h2>
        <p className="apple-lede">
          Design and build under one roof — so vision, detail, and delivery stay
          connected from the first sketch to handover.
        </p>
      </div>

      <div className="apple-wrap--wide apple-services-grid">
        {services.map((service) => (
          <motion.article
            key={service.title}
            className="apple-service"
            whileHover={{ y: -4 }}
            transition={{ duration: 0.35 }}
          >
            <i className={service.icon} aria-hidden />
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default Services;
